function waitForElement(selector, trigger, delayInterval, delayTimeout) {
  var interval = setInterval(function () {
    if (
      document &&
      document.querySelector(selector) &&
      document.querySelectorAll(selector).length > 0
    ) {
      clearInterval(interval);
      trigger();
    }
  }, delayInterval);
  setTimeout(function () {
    clearInterval(interval);
  }, delayTimeout);
}
function live(selector, event, callback, context) {
  /****Helper Functions****/
  // helper for enabling IE 8 event bindings
  function addEvent(el, type, handler) {
    if (el.attachEvent) el.attachEvent("on" + type, handler);
    else el.addEventListener(type, handler);
  }
  // matches polyfill
  this.Element &&
    (function (ElementPrototype) {
      ElementPrototype.matches =
        ElementPrototype.matches ||
        ElementPrototype.matchesSelector ||
        ElementPrototype.webkitMatchesSelector ||
        ElementPrototype.msMatchesSelector ||
        function (selector) {
          var node = this,
            nodes = (node.parentNode || node.document).querySelectorAll(selector),
            i = -1;
          while (nodes[++i] && nodes[i] != node);
          return !!nodes[i];
        };
    })(Element.prototype);
  // live binding helper using matchesSelector
  function live(selector, event, callback, context) {
    addEvent(context || document, event, function (e) {
      var found,
        el = e.target || e.srcElement;
      while (el && el.matches && el !== context && !(found = el.matches(selector))) el = el.parentElement;
      if (el && found) callback.call(el, e);
    });
  }
  live(selector, event, callback, context);
}
function quantityCounter() {
      var countElement = document.getElementById("count");
      var count = 0;

      var decreaseBtn = document.getElementById("decreaseBtn");
      decreaseBtn.addEventListener("click", decrease);

      var increaseBtn = document.getElementById("increaseBtn");
      increaseBtn.addEventListener("click", increase);

      function decrease() {
        if (count > 1) {
          count--;
          countElement.textContent = count;
        }
      }

      function increase() {
        count++;
        countElement.textContent = count;
      }
    }
function changeImage() {
      document.querySelector(".product-bundle__content .product-bundle__image").innerHTML = `<img src="${orImage}"/>`;
      document.querySelectorAll(".swatchBundleItems .eg-swatch-clrs .swatch-element").forEach((changeSwatch) => {
        changeSwatch.addEventListener("click", function () {
            const ImageValue = this.querySelector("input").value;
            let imageURL = orImage;
            if(ImageValue == 'Argent'){
                imageURL = argentImage;
            }else if(ImageValue == 'Or Rose'){
                imageURL = roseGoldImage;
            }else if(ImageValue == 'Or'){
                imageURL = orImage;
            }
          document.querySelector(".product-bundle__content .product-bundle__image").innerHTML = `<img src="${imageURL}"/>` ;
        })
      })
    }
const addToBagGift = (qty, pID) => {
      fetch("https://www.mylittlenecklace.co/cart/add.js", {
        "headers": {
          "accept": "application/json, text/javascript, */*; q=0.01",
          "accept-language": "en-GB,en-US;q=0.9,en;q=0.8",
          "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
          "sec-fetch-dest": "empty",
          "sec-fetch-mode": "cors",
          "sec-fetch-site": "same-origin",
          "x-requested-with": "XMLHttpRequest"
        },
        "body": `quantity=${qty}&id=${pID}`,
        "method": "POST",
        "mode": "cors",
        "credentials": "include"
      }).then((res) => {
        console.log("gift added to cart");
      })
    }
 live(['.template-collection .MainProductSwatch .swatch-element label', '.template-index .MainProductSwatch .swatch-element label', '.eg-request-el .swatch-element label'], 'click', function () {
    const imgEl = this.closest(".product-block__link").querySelector(".rimage__image");
  console.log(this.parentElement.querySelector("input"));
    if ((this.parentElement.querySelector("input")) && (this.parentElement.querySelector("input").getAttribute("data-image-src").indexOf("gif") == -1)) {
       console.log(imgEl);
      imgEl.src = this.parentElement.querySelector("input").getAttribute("data-image-src").replace("small", "540x");
      imgEl.setAttribute("srcset", this.parentElement.querySelector("input").getAttribute("data-image-src").replace("small", "540x"));
       console.log(imgEl);
    }
    this.closest(".swatch-element").parentElement.querySelector(".swatch-element.active") && this.closest(".swatch-element").parentElement.querySelector(".swatch-element.active").classList.remove("active");
    this.closest(".swatch-element").classList.add("active");
  });

jQuery(document).ready(function($){
  setTimeout(function(){
    console.log("event Fire time");
  $('[lengthDefaultObject]').click(function(){
    $(this).parents('.LengthCollectiveObject').toggleClass('length-active');
    $(this).parents('.LengthCollectiveObject').children('.VariantOptionsLengthmn').toggleClass('show-dropdown');
  });

  var LengthVariant = document.querySelectorAll('.VariantOptionsLengthmn li');
  for (var i = 0; i < LengthVariant.length; i++) {
    LengthVariant[i].addEventListener('click', function(event) {
      $(this).addClass('active').siblings().removeClass('active');
      $(this).parents('.LengthCollectiveObject').removeClass('length-active');
      $(this).parents('.VariantOptionsLengthmn').removeClass('show-dropdown');
      var HtmlOfLi = $(this).children('.variantName').html();
      var HtmlOfmg = $(this).children('.variantImg').children('img').attr('src');
      $(this).parents('.LengthCollectiveObject').children('.defaultVariantmn').children('[lengthdefaultobject]').children('img').attr('src',HtmlOfmg);
      $(this).parents('.LengthCollectiveObject').children('.defaultVariantmn').children('[lengthdefaultobject]').children('[type="text"]').val(HtmlOfLi);
      var optionIndex = event.target.closest('.MainProductSwatchLength').getAttribute('main-option-index');
      var optionValue = $(this).children('.variantName').html();
      var trig = event.target.closest('form').querySelector('#SingleOptionSelector-'+optionIndex);
      trig.value = optionValue;
      var event = new Event('change');
      trig.dispatchEvent(event);
    });
  }

  var Colorvariants = document.querySelectorAll('[main-option-index="0"] input[type=radio]');
  for (var i = 0; i < Colorvariants.length; i++) {
    Colorvariants[i].addEventListener('click', function(event) {
      $(this).parents('.swatch-element').addClass('active').siblings().removeClass('active');
      var optionIndex = event.target.closest('.swatch').getAttribute('main-option-index');
      var optionValue = event.target.value;
      var trig = event.target.closest('form').querySelector('#SingleOptionSelector-'+optionIndex);
      trig.value = optionValue;
      var event = new Event('change');
      trig.dispatchEvent(event);
    });    
  }
  
  if( $('.VariantOptionsLengthmn').length != 1 ){
    console.log('length-active')
    var Colorvariants = document.querySelectorAll('[main-option-index="1"] input[type=radio]');
    for (var i = 0; i < Colorvariants.length; i++) {
      Colorvariants[i].addEventListener('click', function(event) {
        $(this).parents('.swatch-element').addClass('active').siblings().removeClass('active');
        var optionIndex = event.target.closest('.swatch').getAttribute('main-option-index');
        var optionValue = event.target.value;
        var trig = event.target.closest('form').querySelector('#SingleOptionSelector-'+optionIndex);
        trig.value = optionValue;
        var event = new Event('change');
        trig.dispatchEvent(event);
      }); 
    }
  }
  
  var Colorvariants = document.querySelectorAll('[main-option-index="2"] input[type=radio]');
  for (var i = 0; i < Colorvariants.length; i++) {
    Colorvariants[i].addEventListener('click', function(event) {
      $(this).parents('.swatch-element').addClass('active').siblings().removeClass('active');
      var optionIndex = event.target.closest('.swatch').getAttribute('main-option-index');
      var optionValue = event.target.value;
      var trig = event.target.closest('form').querySelector('#SingleOptionSelector-'+optionIndex);
      trig.value = optionValue;
      var event = new Event('change');
      trig.dispatchEvent(event);
    }); 
  }
  },1000);
  const collectionPages = [
      "/collections/tous-nos-colliers-et-pendentifs/",
      "/collections/colliers-pendentifs",
      "/collections/pendentifs/",
      "/collections/1-inscription",
      "/collections/2-inscriptions",
      "/collections/3-inscriptions",
      "/collections/4-inscriptions-ou-plus",
      "/collections/initiales",
      "/collections/origami",
      "/collections/signes-du-zodiac",
      "/collections/bijoux-avec-pierre"
    ];
   const currentPath = window.location.pathname;

      /*if (collectionPages.some(path => currentPath.includes(path))) {
        document.body.classList.add("eg-pdp");
      } else {
        document.body.classList.add("eg-not-pdp");
      }*/
  const title = $(".MainProductSwatchLength .MnSwatchLengthHeader .header").text();
  if(title.match("Longueur de Chaîne") || title.match("Taille du Collier")){
    document.body.classList.add("eg-pdp");
  }
  // live('.eg-clr-circle', 'click', function () {
  //     this.parentElement.querySelector("label") && this.parentElement.querySelector("label").click();
  //   });
  //  waitForElement(".product-bundle__items  .swatch:nth-of-type(2) .header", function () {
  //       document.querySelector(".product-bundle__items  .swatch:nth-of-type(2) .header").innerText = "Taille";
  //     }, 50, 15000);
  // waitForElement(".product-bundle__items .swatch:nth-of-type(2) .swatch-element label", function () {
  //       var labels = document.querySelectorAll('.product-bundle__items .swatch:nth-of-type(2) .swatch-element label');
  //       for (var i = 0; i < labels.length; i++) {
  //         var labelText = labels[i].textContent;
  //         labelText = labelText.replace(/\s/g, '');
  //         labelText = labelText.replace('cm-', '-');
  //         labels[i].textContent = labelText;
  //       }
  //     }, 1000, 15000);

  //   waitForElement(".product-bundle__wrapper > .product-bundle__content h3", function () {
  //       if (document.querySelector(".product-bundle__wrapper > .product-bundle__content h3")) {
  //         //document.querySelector(".product-bundle__wrapper > .product-bundle__content h3").innerText = "Offrez-en un deuxième en cadeau !";
  //       }
  //     }, 100, 25000);
  // waitForElement(".gift_products_inner .cv__product_price", function () {
  //       quantityCounter();
  //     }, 100, 25000);
  // waitForElement(".product-bundle__content .product-bundle__image", changeImage, 100, 15000);
  //  waitForElement(".gift_products_inner .product-bundle__image_gift img", function () {
  //       document.querySelector(".gift_products_inner .product-bundle__image_gift img").setAttribute("src", giftImage);
  //     }, 100, 15000);
  // waitForElement(".gift_products_outer .product-bundle__info h3", function () {
  //       if (document.querySelector(".gift_products_outer .product-bundle__info h3")) {
  //         //document.querySelector(".gift_products_outer .product-bundle__info h3").innerText = "Ajoutez une boîte cadeau";
  //       }
  //     }, 50, 15000);
  // live(".product-bundle__atc", "click", function () {
  //     const giftBx = document.querySelector(".gift_repeated");
  //     const checkBx = giftBx.querySelector("#giftboxmsg");
  //     if (checkBx && checkBx.checked) {
  //       waitForElement(".ajax-cart__drawer.is-open", function () {
  //         waitForElement("#giftpro", function () {
  //           const gId = document.querySelector("#giftpro").getAttribute("value");
  //           const gQty = Number(giftBx.querySelector(".eg-counter > #count").innerText.trim()) - 1;
  //           /*if(document.querySelector(`.ajax-cart-item__info[data-id="${gId}"]`) && document.querySelector(`.ajax-cart-item__info[data-id="${gId}"]`).parentElement && document.querySelector(`.ajax-cart-item__info[data-id="${gId}"]`).parentElement.querySelector(".ajax-cart-item__image")){
  //             document.querySelector(`.ajax-cart-item__info[data-id="${gId}"]`).parentElement.querySelector(".ajax-cart-item__image").src = cartGiftImage;
  //             console.log(document.querySelector(`.ajax-cart-item__info[data-id="${gId}"]`).parentElement);
  //           }*/
  //           addToBagGift(gQty, gId);
  //           // updating value in cart
  //           setTimeout(() => {
  //             fetch("https://www.mylittlenecklace.co/cart").then(res => {
  //               const html = res.text();
  //               return html;
  //             }).then(html => {
  //               const el = document.createElement("div");
  //               el.innerHTML = html;
  //               const product = el.querySelector(`.cart-item .cart-item-description a[href*="${gId}"]`).closest(".cart-item").querySelector('.quantity-adjuster__input');
  //               if (product) {
  //                 document.querySelector(`.ajax-cart-item__info[data-id="${gId}"]`).parentElement.querySelector(".ajax-cart-item__input-quantity").value = product.value;
  //                 console.log("value updated to new ", product.value);
  //                 //document.querySelector(`.ajax-cart-item__info[data-id="${gId}"]`).parentElement.querySelector(".ajax-cart-item__image").src = cartGiftImage;
  //               }
  //             })
  //           }, 1300);
  //         }, 50, 15000);
  //       }, 50, 15000);
  //     }
  //   });

    $(document).on("click",'.faqs-item',function() {
      $(this).toggleClass('active');
      $(this).find('.faqs-item-content').slideToggle('fast');
    });
    $(document).on("click",'.custom-accordian-wrapper',function() {
      $(this).toggleClass('active');
      $(this).find('.custom-accordian-content').slideToggle('fast');
    });
});
// $('input[name="bundle_selc"]').change(function(e){
//   var id = $(this).attr('data-id');
//   var img = $(this).attr('data-image-src');
//   setTimeout(function(){
//     $('#bundleForm [name="id"]').val(id);
//     $('.product-bundle__image img').attr('src', img);
//   },200);
// });

// $('.product-bundle__selc').click(function(){
//   $('#bundleProduct').attr('checked',this.checked);
//   $('.product-bundle__properties').toggle(this.checked);
//   if(this.checked == true){
//     $('#product-bundle-price').html($('#product-bundle-price').attr('data-bundleprice'));
//   }else{
//     $('#product-bundle-price').html($('#product-bundle-price').attr('data-price'));
//   }
// });

$(document).on('change  paste','.option-type-text.option-required input',function(e){
  var titles = [];            
  $('.option-type-text.option-required input').each(function(){
    if ($(this).val()) {
      titles.push($(this).val());
    }
  }); 
  $('#mainProduct').attr('data-prop',titles);
});

// $('#product-bundle__prop').on('change keyup paste',function(){
//   $('#bundleProduct').attr('data-prop',$(this).val());
//   $('#bundleText').attr('data-prop',$(this).val());
//   $('#bundleText').val($(this).val()).change();
// });

$('#SingleOptionSelector-0').change(function(){
  setTimeout(function(){
    $('#mainProduct').attr('data-id',$('[data-product-select]').val());
  },200);
});
$('#select2-quantity-proxy-container').on('DOMSubtreeModified',function(){
  setTimeout(function(){
    $('#mainProduct').attr('data-qty',$(this).html());
  },200);
});

// $('.product-bundle__title').click(function(){
//   $(this).parents('.product-bundle__item').siblings().removeClass('Cv_Active_Item');
//   $(this).parents('.product-bundle__item').addClass('Cv_Active_Item');
// });



(function () {
  const hours = document.getElementById("hours");
  const minutes = document.getElementById("minutes");
  const seconds = document.getElementById("seconds");
  const countdown = document.getElementById("countdown");
  var d = new Date();
  const newYearTime = d.setHours(24,0,0,0);

  function updateCountdown() {
    const currentTime = new Date();
    const difference = newYearTime - currentTime;
    const currentDays = Math.floor(difference / 1000 / 60 / 60 / 24);
    const currentHours = Math.floor(difference / 1000 / 60 / 60) % 24;
    const currentMinutes = Math.floor(difference / 1000 / 60) % 60;
    const currentSeconds = Math.floor(difference / 1000) % 60;
    hours.innerText = currentHours < 10 ? "0" + currentHours : currentHours;
    minutes.innerText = currentMinutes < 10 ? "0" + currentMinutes : currentMinutes;
    seconds.innerText = currentSeconds < 10 ? "0" + currentSeconds : currentSeconds;
  }
  if(document.getElementById("timer-dots-hr")){
     document.getElementById("timer-dots-hr").innerText = ':';
    document.getElementById("timer-dots-mn").innerText = ':';
    setInterval(updateCountdown, 1000);
  }
 
}());



$('[data-option-index="0"]').children('.swatch-element').children('input').click(function(){
  var ObjectSwatch = $(this).attr('data-title');
  var objectTitle = $(this).attr('value');
  var ObjectId = $(this).attr('data-id');
  var optionedCheckedValue = $('[data-option-index="1"]').children('.swatch-element').children('input:checked').attr('value');
  var SecondoptionedCheckedValue = $('[data-option-index="2"]').children('.swatch-element').children('input:checked').attr('value');

  if( $('[data-option-index="2"]').length > 0 ){
    var concatVal = objectTitle+' / '+optionedCheckedValue+' / '+SecondoptionedCheckedValue;
  }
  else if( $('[data-option-index="1"]').length > 0 ){
    var concatVal = objectTitle+' / '+optionedCheckedValue;
  }
  else{
    var concatVal = objectTitle;
  }

  $(this).parents('.swatch-element').addClass('Cv_Active_Item').siblings().removeClass('Cv_Active_Item');
  if( ObjectSwatch == 'Couleur' ){
    var ObjectImage = $(this).attr('data-image-src');
    $(this).parents('.product-bundle__wrapper').children('.product-bundle__content').children('.product-bundle__image').children('img').attr('src',ObjectImage);
  }

  $(this).parents('.swatchBundleItems').children('.HiddenVariant').children('li').each(function(){
    var dataName = $(this).attr('data-name');
    if( concatVal == dataName){
      var GoiId = $(this).attr('data-vid');
      $('#bundleForm').children('[name="id"]').val(GoiId);
      return false;
    }
  });

});

$('[data-option-index="1"]').children('.swatch-element').children('input').click(function(){

  var ObjectSwatch = $(this).attr('data-title');
  var objectTitle = $(this).attr('value');
  var ObjectId = $(this).attr('data-id');
  var optionedCheckedValue = $('[data-option-index="0"]').children('.swatch-element').children('input:checked').attr('value');
  var SecondoptionedCheckedValue = $('[data-option-index="2"]').children('.swatch-element').children('input:checked').attr('value');

  if( $('[data-option-index="2"]').length > 0 ){
    var concatVal = optionedCheckedValue+' / '+objectTitle+' / '+SecondoptionedCheckedValue;
  }
  else{
    var concatVal = optionedCheckedValue+' / '+objectTitle;
  }

  $(this).parents('.swatch-element').addClass('Cv_Active_Item').siblings().removeClass('Cv_Active_Item');
  if( ObjectSwatch == 'Couleur' ){
    var ObjectImage = $(this).attr('data-image-src');
    $(this).parents('.product-bundle__wrapper').children('.product-bundle__content').children('.product-bundle__image').children('img').attr('src',ObjectImage);
  }

  $(this).parents('.swatchBundleItems').children('.HiddenVariant').children('li').each(function(){
    var dataName = $(this).attr('data-name');
    if( concatVal == dataName){
      var GoiId = $(this).attr('data-vid');
      $('#bundleForm').children('[name="id"]').val(GoiId);
      return false;
    }
  });

});

$('[data-option-index="2"]').children('.swatch-element').children('input').click(function(){
  var ObjectSwatch = $(this).attr('data-title');
  var objectTitle = $(this).attr('value');
  var ObjectId = $(this).attr('data-id');
  var optionedCheckedValue = $('[data-option-index="0"]').children('.swatch-element').children('input:checked').attr('value');
  var SecondoptionedCheckedValue = $('[data-option-index="1"]').children('.swatch-element').children('input:checked').attr('value');
  var concatVal = optionedCheckedValue+' / '+SecondoptionedCheckedValue+' / '+objectTitle;

  $(this).parents('.swatch-element').addClass('Cv_Active_Item').siblings().removeClass('Cv_Active_Item');
  if( ObjectSwatch == 'Couleur' ){
    var ObjectImage = $(this).attr('data-image-src');
    $(this).parents('.product-bundle__wrapper').children('.product-bundle__content').children('.product-bundle__image').children('img').attr('src',ObjectImage);
  }

  $(this).parents('.swatchBundleItems').children('.HiddenVariant').children('li').each(function(){
    var dataName = $(this).attr('data-name');
    if( concatVal == dataName){
      var GoiId = $(this).attr('data-vid');
      $('#bundleForm').children('[name="id"]').val(GoiId);
      return false;
    }
  });
});


jQuery(document).ready(function($){
/*
  $(document).on("click",'[lengthDefaultObject]',function(){
    $(this).parents('.LengthCollectiveObject').toggleClass('length-active');
    $(this).parents('.LengthCollectiveObject').children('.VariantOptionsLengthmn').toggleClass('show-dropdown');
  });

  var LengthVariant = document.querySelectorAll('.VariantOptionsLengthmn li');
  for (var i = 0; i < LengthVariant.length; i++) {
    LengthVariant[i].addEventListener('click', function(event) {
      $(this).addClass('active').siblings().removeClass('active');
      $(this).parents('.LengthCollectiveObject').removeClass('length-active');
      $(this).parents('.VariantOptionsLengthmn').removeClass('show-dropdown');
      var HtmlOfLi = $(this).children('.variantName').html();
      var HtmlOfmg = $(this).children('.variantImg').children('img').attr('src');
      $(this).parents('.LengthCollectiveObject').children('.defaultVariantmn').children('[lengthdefaultobject]').children('img').attr('src',HtmlOfmg);
      $(this).parents('.LengthCollectiveObject').children('.defaultVariantmn').children('[lengthdefaultobject]').children('[type="text"]').val(HtmlOfLi);
      var optionIndex = event.target.closest('.MainProductSwatchLength').getAttribute('main-option-index');
      var optionValue = $(this).children('.variantName').html();
      var trig = event.target.closest('form').querySelector('#SingleOptionSelector-'+optionIndex);
      trig.value = optionValue;
      var event = new Event('change');
      trig.dispatchEvent(event);
    });
  }

  var Colorvariants = document.querySelectorAll('[main-option-index="0"] input[type=radio]');
  for (var i = 0; i < Colorvariants.length; i++) {
    Colorvariants[i].addEventListener('click', function(event) {
      $(this).parents('.swatch-element').addClass('active').siblings().removeClass('active');
      var optionIndex = event.target.closest('.swatch').getAttribute('main-option-index');
      var optionValue = event.target.value;
      var trig = event.target.closest('form').querySelector('#SingleOptionSelector-'+optionIndex);
      trig.value = optionValue;
      var event = new Event('change');
      trig.dispatchEvent(event);
    });    
  }
  
  if( $('.VariantOptionsLengthmn').length != 1 ){
    console.log('length-active')
    var Colorvariants = document.querySelectorAll('[main-option-index="1"] input[type=radio]');
    for (var i = 0; i < Colorvariants.length; i++) {
      Colorvariants[i].addEventListener('click', function(event) {
        $(this).parents('.swatch-element').addClass('active').siblings().removeClass('active');
        var optionIndex = event.target.closest('.swatch').getAttribute('main-option-index');
        var optionValue = event.target.value;
        var trig = event.target.closest('form').querySelector('#SingleOptionSelector-'+optionIndex);
        trig.value = optionValue;
        var event = new Event('change');
        trig.dispatchEvent(event);
      }); 
    }
  }
  
  var Colorvariants = document.querySelectorAll('[main-option-index="2"] input[type=radio]');
  for (var i = 0; i < Colorvariants.length; i++) {
    Colorvariants[i].addEventListener('click', function(event) {
      $(this).parents('.swatch-element').addClass('active').siblings().removeClass('active');
      var optionIndex = event.target.closest('.swatch').getAttribute('main-option-index');
      var optionValue = event.target.value;
      var trig = event.target.closest('form').querySelector('#SingleOptionSelector-'+optionIndex);
      trig.value = optionValue;
      var event = new Event('change');
      trig.dispatchEvent(event);
    }); 
  }
 */
  
});

// $(document).ready(function(){
//   var $txtArea = $('.product_preview_wrapper input[type="text"]');
//   var textMax = $txtArea.attr('maxlength');
//   var textLength = $txtArea.val().length;
//   var textRemaining = $txtArea.attr('maxlength');
//   function countChar() {
//     var textLength = $(this).val().length;
//     $(this).siblings('.remaing_char').html(`${textLength}/${textMax}`);
//   }
//   function changeaddtocarttext(){
//      //$('.product-bundle__atc').text('Entrez le nom/mot de votre choix*');
//      //$(".product-bundle__atc").css({"background": "#D9D9D9"});
//      //$(".product-bundle__atc").attr("disabled", true);
//       if($(".product_preview_wrapper").length > 0){
//             if($(".product_preview_wrapper").length > 0){
//               $(".product_preview_wrapper input[type='text']").each(function() {
//             if ($(this).siblings('.remaing_char').length === 0) {
//                 let html = `<p class="remaing_char">${$(this).val().length}/${textMax}</p>`;
//                 $(this).after(html);
//             }
//         });
//             }
//          $txtArea.on('input', countChar); 
//         if($(".LengthSizeImagePopupForGuide-d-inscriptions").length > 0){
//             $( ".product-customizer-option.option-type-text .product-customizer-option-description").append( `<label class="opener-for-guide-popup-custom"><u>Guide d’inscriptions</u></label>`);
//         }
        
   
//         $(document).on("input", ".option-required input[type='text']", function() {
//         var empty = false;
//           if (($(this).val() == '')) {
//             empty = true;
//             $(this).parents(".custom-input-wrapper-preview").removeClass("preview-displayed");
//           }else{
//              $(this).parents(".custom-input-wrapper-preview").addClass("preview-displayed");
//           }
//         if (empty) {
//            //$(".product-bundle__atc").attr("disabled", true);
//            //$('.product-bundle__atc').text('Entrez le nom/mot de votre choix*');
//            $(".product-bundle__atc").css({"background": "#D9D9D9"});
//         } else {
//            $(".product-bundle__atc").attr("disabled", false);
//           $('.product-bundle__atc').text($('.product-bundle__atc').data("addcarttext"));
//           $(".product-bundle__atc").css({"background": "linear-gradient(to bottom, #f7dfa5, #f0c14b)"});
//         }
//       }); 
        
       
//     }
//   }
//     if(($('.option-required').length > 0 && $('main.hw16_v1').length > 0) || ($('.option-required').length > 0 && $('body.hw-abt-16-1').length > 0)){
//        changeaddtocarttext();
//      }
  
  
//   const initializeBodyObservation = () => {
//     const targetNode = document.body;
//     const config = { attributes: true };
//     const callback = function(mutationsList, observer) {
//       for (const mutation of mutationsList) {
//         if (mutation.type === 'attributes') {
//           if(targetNode.classList.contains("hw-abt-16-1")){
//                 changeaddtocarttext();
//           }
//         }
//         }
//     };
//     const observer = new MutationObserver(callback);
//     observer.observe(targetNode, config);
//   }
//   initializeBodyObservation();

// });

$(document).on('click','.CaptureLengthPopup', function(e){
  $(this).parents('.product-form-block').find('.LengthSizeImagePopup').addClass('active');
  $('body').addClass('LengthPopupMasked');
})


$(document).click(function (e) {
  if (!$(e.target).closest('.LengthSizeImagePopup.active, .CaptureLengthPopup').length) {
    $('.LengthSizeImagePopup').removeClass('active');
    $('body').removeClass('LengthPopupMasked');
  }
});

function changeText(){
 $(".js-ajax-checkout-button span:eq(1)").text("VALIDER MON PANIER");
}
if($('.js-ajax-checkout-button.v1').length > 0 || $('body.hw-abt-19-1').length > 0){
       changeText();
}
const initializeBodyObservation3 = () => {
  const targetNode = document.body;
  const config = { attributes: true };
  const callback = function(mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName == 'class') {
        if(targetNode.classList.contains("hw-abt-19-1")){
              changeText();
        }
        if(targetNode.classList.contains("hw-abt-14-1")){
          if($(".eg-tiny-slider").length > 0){
            $(".eg-tiny-slider").slick("refresh");
          }
        }
        if(targetNode.classList.contains("hw-abt-15-1") && document.getElementsByClassName('ab015_test').length > 0){
        $('.product-thumbnails').slick('unslick');
        }
      }
      }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}
  initializeBodyObservation3();


/*jQuery(document).ready(function($){
  $(document).on("click",".customTemplate .swatch-element label",function(){
    const imgEl = $(this).parent(".product-block__link").find(".rimage__image");
    console.log(imgEl);
    if (($(this).parent(".swatch-element").find("input")) && ($(this).parent(".swatch-element").find("input").attr("data-image-src").indexOf("gif") == -1)) {
      imgEl.attr('src',$(this).parent(".swatch-element").find("input").attr("data-image-src").replace("small", "540x"));
      imgEl. attr("srcset", $(this).parent(".swatch-element").find("input").attr("data-image-src").replace("small", "540x"));
    }
    $(this).parent(".swatch-element").parent(".MainProductSwatch").find(".swatch-element.active") &&  $(this).parent(".swatch-element").parent(".MainProductSwatch").find(".swatch-element.active").removeClass("active");
    $(this).parent(".swatch-element").addClass("active");
      
  });
});*/
if (!customElements.get('simple-progress-bar')) {
  customElements.define(
    'simple-progress-bar',
    class SimpleProgressBar extends HTMLElement {
      constructor() {
        super();

        this.threshold = +this.dataset.threshold;
        this.threshold2 = +this.dataset.threshold2;
        this.threshold3 = +this.dataset.threshold3;
        

        this.giftProducts = this.dataset.productid;
        this.gift2Products = this.dataset.productid2;
        this.gift3Products = this.dataset.productid3;

        this.t1MatchedProducts = [];
        this.t2MatchedProducts = [];
        this.t3MatchedProducts = [];
        this.totalMatchedCart = [];
        this.productIds = [];
        this.init();
      }
      calculatePercentage(amount) {
          let percentage = 0;
          if(this.threshold3 <= 0){
             if(amount <= this.threshold){
              percentage = ((amount/this.threshold)*20);
            }else if(amount > this.threshold && amount <= this.threshold2){
              percentage = ((amount/this.threshold2)*66);
            }else if(amount >= this.threshold2){
              percentage = 100;
            }    
          }else{
            if(amount <= this.threshold){
              percentage = ((amount/this.threshold)*11);
            }else if(amount > this.threshold && amount <= this.threshold2){
              percentage = ((amount/this.threshold2)*46);
            }else if(amount > this.threshold2 && amount < this.threshold3){
              percentage = ((amount/this.threshold3)*81);
            }else if(amount >= this.threshold3){
              percentage = 100;
            }    
          }
          
          return percentage;
      }
      async init() {
          this.t1MatchedProducts = [];
          this.t2MatchedProducts = [];
          this.t3MatchedProducts = [];
          this.totalMatchedCart = [];
          this.productIds = [];
          this.thirdGifItems = [];
          this.secondGifItems = [];
          this.firstGifItems = [];
        
          if(this.giftProducts != ""){
            this.firstGifItems = this.giftProducts.split("___");
          }
          if(this.gift2Products != ""){
            this.secondGifItems = this.gift2Products.split("___");
          }
          if(this.gift3Products != "" && this.threshold3 > 0){
            this.thirdGifItems = this.gift3Products.split("___");
          }
          let progressBar1 = this.querySelector("#progressbar1");
         
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
         
          let giftPrice = 0;
        
          const giftMatched = cart.items.filter(item => this.firstGifItems.includes(`${item.id}`) && item.properties._isGift == 1);
          if(giftMatched.length > 0){
            this.t1MatchedProducts = giftMatched;
            for(let i in giftMatched){
              giftPrice = giftPrice + giftMatched[i].final_line_price;
              this.totalMatchedCart.push(giftMatched[i]);
            }
          }
          const giftMatched2 = cart.items.filter(item => this.secondGifItems.includes(`${item.id}`) && item.properties._isGift == 1);
          if(giftMatched2.length > 0){
            this.t2MatchedProducts = giftMatched2;
            for(let i in giftMatched2){
              giftPrice = giftPrice + giftMatched2[i].final_line_price;
               this.totalMatchedCart.push(giftMatched2[i]);
            }
          }
          const giftMatched3 = cart.items.filter(item => this.thirdGifItems.includes(`${item.id}`) && item.properties._isGift == 1);
          if(giftMatched3.length > 0){
            this.t3MatchedProducts = giftMatched3;
            for(let i in giftMatched3){
              giftPrice = giftPrice + giftMatched3[i].final_line_price;
               this.totalMatchedCart.push(giftMatched3[i]);
            }
          }
          const cartTotalIncent = (cart.total_price - giftPrice);
          const cartTotal = cartTotalIncent/100;
          let percentage = (cartTotal / this.threshold3) * 100;
        
          percentage = this.calculatePercentage(cartTotal);
        if(this.threshold3 <= 0){
          if(cartTotal >= this.threshold2){
             this.productIds = [];
            
            if(this.firstGifItems.length > 0 && giftMatched.length <= 0){
              for(let i in this.firstGifItems){
                  this.productIds.push(this.firstGifItems[i]);
              }
            }
            if(this.secondGifItems.length > 0 && giftMatched2.length <= 0){
               for(let i in this.secondGifItems){
                  this.productIds.push(this.secondGifItems[i]);
                }
            }
           
            if(this.productIds.length > 0){
                this.addGifts(1);
            }
            const amountIncent = ( this.threshold3 * 100);
            const sippingAmount = (amountIncent - cartTotalIncent);
            this.updateMessage(2,sippingAmount);
          }else if(cartTotal >= this.threshold && cartTotal < this.threshold2){
             this.productIds = [];
            this.needToRemoved = [];
            if(this.thirdGifItems.length > 0 && giftMatched3.length > 0){
              for(let i in giftMatched3){
                  this.needToRemoved.push(giftMatched3[i]);
              }
            }
            if(this.secondGifItems.length > 0 && giftMatched2.length > 0){
              for(let i in giftMatched2){
                  this.needToRemoved.push(giftMatched2[i]);
              }
            }
            
            if(this.firstGifItems.length > 0 && giftMatched.length <= 0){
              for(let i in this.firstGifItems){
                  this.productIds.push(this.firstGifItems[i]);
                }
            }
            if(this.needToRemoved.length > 0){
              let updates = this.needToRemoved.reduce((acc, { key, quantity }) => {
                acc[key] = 0;
                return acc;
               }, {});
              this.removeGifts(updates,(this.productIds.length <= 0));
            }
            if(this.productIds.length > 0){
                this.addGifts(1);
            }
            const amountIncent = ( this.threshold2  * 100);
            const sippingAmount = (amountIncent - cartTotalIncent);
            this.updateMessage(1,sippingAmount);
          }else if(cartTotal< this.threshold){
            if(this.totalMatchedCart.length > 0){
              let updates = this.totalMatchedCart.reduce((acc, { key, quantity }) => {
                acc[key] = 0;
                return acc;
               }, {});
              this.removeGifts(updates,1);
            }
            const amountIncent = ( this.threshold  * 100);
            const sippingAmount = (amountIncent - cartTotalIncent);
            this.updateMessage(0,sippingAmount);
          }
        }else{
          if(cartTotal >= this.threshold3){
              this.productIds = [];
              if(this.firstGifItems.length > 0 && giftMatched.length <= 0){
                for(let i in this.firstGifItems){
                    this.productIds.push(this.firstGifItems[i]);
                  }
              }
              if(this.secondGifItems.length > 0 && giftMatched2.length <= 0){
                 for(let i in this.secondGifItems){
                    this.productIds.push(this.secondGifItems[i]);
                  }
              }
              if(this.thirdGifItems.length > 0 && giftMatched3.length <= 0){
                 for(let i in this.thirdGifItems){
                    this.productIds.push(this.thirdGifItems[i]);
                  }
              }

            if(this.productIds.length > 0){
              this.addGifts(1);
            }
            const amountIncent = ( this.threshold3 * 100);
             const sippingAmount = (amountIncent - cartTotalIncent);
           this.updateMessage(3,sippingAmount);
            
          }else if(cartTotal >= this.threshold2 && cartTotal < this.threshold3){
             this.productIds = [];
            
            if(this.firstGifItems.length > 0 && giftMatched.length <= 0){
              for(let i in this.firstGifItems){
                  this.productIds.push(this.firstGifItems[i]);
              }
            }
            if(this.secondGifItems.length > 0 && giftMatched2.length <= 0){
               for(let i in this.secondGifItems){
                  this.productIds.push(this.secondGifItems[i]);
                }
            }
           if(this.thirdGifItems.length > 0 && giftMatched3.length > 0){
              let updates = giftMatched3.reduce((acc, { key, quantity }) => {
                acc[key] = 0;
                return acc;
               }, {});
              this.removeGifts(updates,(this.productIds.length <= 0));
            }
            if(this.productIds.length > 0){
                this.addGifts(1);
            }
            const amountIncent = ( this.threshold3 * 100);
            const sippingAmount = (amountIncent - cartTotalIncent);
            this.updateMessage(2,sippingAmount);
          }else if(cartTotal >= this.threshold && cartTotal < this.threshold2){
             this.productIds = [];
            this.needToRemoved = [];
            if(this.thirdGifItems.length > 0 && giftMatched3.length > 0){
              for(let i in giftMatched3){
                  this.needToRemoved.push(giftMatched3[i]);
              }
            }
            if(this.secondGifItems.length > 0 && giftMatched2.length > 0){
              for(let i in giftMatched2){
                  this.needToRemoved.push(giftMatched2[i]);
              }
            }
            
            if(this.firstGifItems.length > 0 && giftMatched.length <= 0){
              for(let i in this.firstGifItems){
                  this.productIds.push(this.firstGifItems[i]);
                }
            }
            if(this.needToRemoved.length > 0){
              let updates = this.needToRemoved.reduce((acc, { key, quantity }) => {
                acc[key] = 0;
                return acc;
               }, {});
              this.removeGifts(updates,(this.productIds.length <= 0));
            }
            if(this.productIds.length > 0){
                this.addGifts(1);
            }
            const amountIncent = ( this.threshold2  * 100);
            const sippingAmount = (amountIncent - cartTotalIncent);
            this.updateMessage(1,sippingAmount);
          }else if(cartTotal< this.threshold){
            if(this.totalMatchedCart.length > 0){
              let updates = this.totalMatchedCart.reduce((acc, { key, quantity }) => {
                acc[key] = 0;
                return acc;
               }, {});
              this.removeGifts(updates,1);
            }
            const amountIncent = ( this.threshold  * 100);
            const sippingAmount = (amountIncent - cartTotalIncent);
            this.updateMessage(0,sippingAmount);
          }
        }
          
    
           progressBar1.style.width=`${percentage}%`;
      }
      updateMessage(t,amount){
        if(this.threshold3 <= 0){
          if(t == 2){
              this.querySelector(".bar-icon-wrapper.first-box").classList.add("activated");
              this.querySelector(".bar-icon-wrapper.second-box").classList.add("activated");
              this.querySelector(".t1_message-wrapper").classList.add("hide");
              this.querySelector(".t2_message-wrapper").classList.add("hide");
              this.querySelector(".success_message-wrapper").classList.remove("hide");
          }else if(t == 1){
              this.querySelector(".bar-icon-wrapper.first-box").classList.add("activated");
              this.querySelector(".bar-icon-wrapper.second-box").classList.remove("activated");
              this.querySelector(".t1_message-wrapper").classList.add("hide");
              this.querySelector(".t2_message-wrapper").classList.remove("hide");
              this.querySelector(".t2_message-wrapper .custom-amount").textContent = slate.Currency.formatMoney(amount, theme.moneyFormat);
              this.querySelector(".success_message-wrapper").classList.add("hide");
          }else{
              this.querySelector(".bar-icon-wrapper.first-box").classList.remove("activated");
              this.querySelector(".bar-icon-wrapper.second-box").classList.remove("activated");
              this.querySelector(".t1_message-wrapper").classList.remove("hide");
              this.querySelector(".t1_message-wrapper .custom-amount").textContent = slate.Currency.formatMoney(amount, theme.moneyFormat);
              this.querySelector(".t2_message-wrapper").classList.add("hide");
              this.querySelector(".success_message-wrapper").classList.add("hide");
          }
        }else{
          if(t == 3){
          this.querySelector(".bar-icon-wrapper.first-box").classList.add("activated");
          this.querySelector(".bar-icon-wrapper.second-box").classList.add("activated");
          this.querySelector(".bar-icon-wrapper.third-box").classList.add("activated");
          this.querySelector(".t1_message-wrapper").classList.add("hide");
          this.querySelector(".t2_message-wrapper").classList.add("hide");
          this.querySelector(".t3_message-wrapper").classList.add("hide");
          this.querySelector(".success_message-wrapper").classList.remove("hide");
        }else if(t == 2){
            this.querySelector(".bar-icon-wrapper.first-box").classList.add("activated");
            this.querySelector(".bar-icon-wrapper.second-box").classList.add("activated");
            this.querySelector(".bar-icon-wrapper.third-box").classList.remove("activated");
            this.querySelector(".t1_message-wrapper").classList.add("hide");
            this.querySelector(".t2_message-wrapper").classList.add("hide");
            this.querySelector(".t3_message-wrapper").classList.remove("hide");
            this.querySelector(".t3_message-wrapper .custom-amount").textContent = slate.Currency.formatMoney(amount, theme.moneyFormat);
            this.querySelector(".success_message-wrapper").classList.add("hide");
        }else if(t == 1){
          this.querySelector(".bar-icon-wrapper.first-box").classList.add("activated");
            this.querySelector(".bar-icon-wrapper.second-box").classList.remove("activated");
            this.querySelector(".bar-icon-wrapper.third-box").classList.remove("activated");
            this.querySelector(".t1_message-wrapper").classList.add("hide");
            this.querySelector(".t2_message-wrapper").classList.remove("hide");
            this.querySelector(".t2_message-wrapper .custom-amount").textContent = slate.Currency.formatMoney(amount, theme.moneyFormat);
            this.querySelector(".t3_message-wrapper").classList.add("hide");
            this.querySelector(".success_message-wrapper").classList.add("hide");
        }else{
          this.querySelector(".bar-icon-wrapper.first-box").classList.remove("activated");
            this.querySelector(".bar-icon-wrapper.second-box").classList.remove("activated");
            this.querySelector(".bar-icon-wrapper.third-box").classList.remove("activated");
            this.querySelector(".t1_message-wrapper").classList.remove("hide");
            this.querySelector(".t1_message-wrapper .custom-amount").textContent = slate.Currency.formatMoney(amount, theme.moneyFormat);
            this.querySelector(".t2_message-wrapper").classList.add("hide");
            this.querySelector(".t3_message-wrapper").classList.add("hide");
            this.querySelector(".success_message-wrapper").classList.add("hide");
        }
        }
        
      }
      removeGifts(updates,isUpdate){
          const body = JSON.stringify({
            updates,
          });
          fetch(`/cart/update.js`,{
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: body
            })
            .then((response) => response.json())
            .then((response) => {
               if(isUpdate == 1){
                if(window.location.pathname == '/cart'){
                   window.location.reload(true);
                  return;
                }
                fetchCart();
              }
          });
        
      }
      addGifts(isUpdate){
        let items = [];
          items = this.productIds.map((id) => {
            return {
              "id":id,
              "quantity":1,
              "properties":{
                "_isGift":1
              }
           };
          });
          let formData = {
           'items':items,
          };
          fetch(`/cart/add.js`,{
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then((response) => response.json())
          .then((response) => {
              if(isUpdate == 1){
                if(window.location.pathname == '/cart'){
                  window.location.reload(true);
                  return;
                }
                fetchCart();
              }
          });  
       }
     }
  );
}
async function loadProgressbarCustom(cart){
  if(ab020Test == 'v1'){
     if($(".custom-gift-bar-placement").length > 0){
      if($(".custom-gift-bar-placement .custom-gift-bar-wrapper").length <= 0 && $(".custom-cart-gift-item-template").length > 0){
        $(".custom-gift-bar-placement").html($(".custom-cart-gift-item-template").html());
      }else if($(".custom-gift-bar-placement").length > 0 && document.querySelector(".custom-gift-bar-placement simple-progress-bar")){
        document.querySelector(".custom-gift-bar-placement simple-progress-bar").init();
      }
    }
  }else if(ab020Test == 'test' && $("body.hw-abt-20-1").length > 0){
    if($(".custom-gift-bar-placement").length > 0){
      if($(".custom-gift-bar-placement .custom-gift-bar-wrapper").length <= 0 && $(".custom-cart-gift-item-template").length > 0){
        $(".custom-gift-bar-placement").html($(".custom-cart-gift-item-template").html());
      }else if($(".custom-gift-bar-placement").length > 0 && document.querySelector(".custom-gift-bar-placement simple-progress-bar")){
        document.querySelector(".custom-gift-bar-placement simple-progress-bar").init();
      }
    }
  }
}